import Lottie from "lottie-react";
import React, { useRef } from "react";
import "./homeScroll.css";
import { useNavigate } from "react-router-dom";
import { FaArrowDownLong } from "react-icons/fa6";
import { Link } from "react-scroll";

const ServiceSmall = ({ servicesData }) => {
  const serviceRefs = [useRef(null), useRef(null), useRef(null)];
  const navigate = useNavigate();

  // Animation files for each service (assuming 3 services)
  const serviceAnimations = [
    require("../../Images/First.json"),
    require("../../Images/Chatbot.json"),
    require("../../Images/Second.json"),
  ];

  if (!servicesData || servicesData.length === 0) {
    return null; // Or return a loading state if preferred
  }

  return (
    <div>
      <div className="row col-11 m-auto text-start gap-4">
        {servicesData.slice(0, 3).map((service, index) => (
          <div
            key={service.id || index}
            className={`rounded-4 col-12 serviceSmall${
              index + 1
            } position-relative`}
            ref={serviceRefs[index]}
          >
            <div className="col-11 my-3">
              <div className="mt-2">
                <p className="fs-1">{service.title}</p>
                <p className="mt-2">{service.text}</p>
                <button
                  className="sumBtn mfs-4 rounded-5 mt-3"
                  onClick={() =>
                    navigate(service.button_url || "/our-products")
                  }
                >
                  {service.button_name || "Explore"}
                </button>
                {index === 0 && (
                  <Link
                    activeClass="active"
                    to={"homeAboutMB"}
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    <button className="homeDownBtn">
                      <p>
                        <FaArrowDownLong className="fw-bold" />
                      </p>
                    </button>
                  </Link>
                )}
              </div>
              <div className={`col-11 m-auto servisJson${index + 1} active`}>
                <Lottie
                  animationData={
                    serviceAnimations[index] || serviceAnimations[0]
                  }
                  loop={true}
                  style={{ height: "100%" }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceSmall;
